import React from "react";

function Error() {
  return (
    <main style={{ textAlign: "center", padding: "200px 0" }}>
      <h1>An Error Occurred!</h1>
      <h4>Could Not Find This Page!</h4>
    </main>
  );
}

export default Error;
